module.exports = __webpack_public_path__ + "assets/img/37_746.b9eddbbf.jpg";